import { SNOW_LOSS_DEFAULTS, SNOW_LOSS_DISPLAY_NAMES } from './SnowLosses/constants'

export const getSnowLossDefaultsForCountry = (countryIso2: string): Record<string, number> => {
  return SNOW_LOSS_DEFAULTS[countryIso2] || ({} as Record<string, number>)
}

export const getDisplayName = (countryIso2: string, locationCode: string): string => {
  const displayNames = SNOW_LOSS_DISPLAY_NAMES[countryIso2]
  return displayNames?.[locationCode] || locationCode
}
